import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BannerAvisoCe from "./F360BannerAviso.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-f360-banner-aviso")) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const CustomElement = defineCustomElement(F360BannerAvisoCe as any);
      customElements.define("vc-f360-banner-aviso", CustomElement);
    }
  }
};

export default _register;
